<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14.6667 8.00001C10.037 8.00001 8.00001 10.037 8.00001 14.6667C8.00001 10.037 5.96297 8.00001 1.33334 8.00001C5.96297 8.00001 8.00001 5.96297 8.00001 1.33334C8.00001 5.96297 10.037 8.00001 14.6667 8.00001Z"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>
